import { spacing } from 'ui/theme';
import { InboxSkeleton, InboxLine, InboxText } from './ContentPreviewInApp.styled';

/**
 * **NOTE** The component in this file is a direct copy of the `InboxLineSkeleton` component found at:
 * `src/modules/templateEditor/EditInApp/preview/InboxPreview.tsx.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does fetch its data from grapqhl, a necessity for the templateEdit preview.
 */
export const InboxLineSkeleton = () => (
  <InboxLine style={{ width: `100%` }}>
    <InboxSkeleton style={{ height: spacing.x4, width: spacing.x4 }} />
    <InboxText>
      <div>
        <InboxSkeleton style={{ height: 17, width: 116, marginBottom: spacing.half }} />
        <InboxSkeleton style={{ height: 8, width: 180 }} />
      </div>
      <InboxSkeleton style={{ height: 8, width: 30 }} />
    </InboxText>
  </InboxLine>
);
